export default "__VITE_ASSET__DgOufbq5__"